import type { IconData } from '@stacksjs/iconify-core'

export const ax4x3: IconData = {
  "body": "<defs><clipPath id=\"SVG97QIkwXQ\"><path fill-opacity=\".7\" d=\"M106.3 0h1133.3v850H106.3z\"/></clipPath></defs><g clip-path=\"url(#SVG97QIkwXQ)\" transform=\"matrix(.56472 0 0 .56482 -60 -.1)\"><path fill=\"#0053a5\" d=\"M0 0h1300v850H0z\"/><g fill=\"#ffce00\"><path d=\"M400 0h250v850H400z\"/><path d=\"M0 300h1300v250H0z\"/></g><g fill=\"#d21034\"><path d=\"M475 0h100v850H475z\"/><path d=\"M0 375h1300v100H0z\"/></g></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ax4x3
